/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Icon, Stack, TooltipHost } from "@fluentui/react";
import { Text } from "@fluentui/react-components";
import { Card, CardProps } from "@fluentui/react-components";
import { PinOffRegular, PlayCircle24Regular } from "@fluentui/react-icons";
import { isFeatureEnabled } from "../../../../../services/FeatureFlagService";

/**
 * Extracted from V2_Tile.tsx — CardElements inner component (Zero Logic Change)
 * Props = CardElements original typed props + every parent-scope variable it referenced.
 */
export interface TileCardParentProps {
  styles: any;
  tileSelected: string;
  validateURL: () => void;
  closeMCAPSPanel: () => void;
  setDetailClick: (val: boolean) => void;
  handleStartClick: () => void;
  setTileSelected: (id: string) => void;
  handleDetailClick: () => void;
  setStartClick: (val: boolean) => void;
  addToWorkspace: (serviceID: string) => void;
  openFAQs: (faqLink: string) => void;
  openPanel: (serviceID: string, isRecommended: boolean, isStart?: boolean) => void;
}

export const CardElements = (
  props: CardProps & TileCardParentProps & {
    title: string;
    aboutService: string;
    displayName: string;
    onDelete: () => void;
    isSegment: boolean;
    isRecommended: boolean;
    serviceID: string;
    faqLink?: string;
    help_Provider?: string;
    slA_logo?: string;
    slA_in_days?: any;
    checkIrisService: () => Promise<boolean | void>;
    setIrisBotIconClicked?: any;
  }
) => {
  const [isHovered, setIsHovered] = useState(false);
  const [focusedTileID, setFocusedTileID] = useState<string | null>(null);

  let blobToken = sessionStorage.getItem("SasTokenKey") || "";
  const altImageUrl = `${
    process.env.REACT_APP_BLOBSASSTART + "optionallogo.svg" + blobToken
  }`;

  // Accessibility: handle keyboard activation
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.target !== e.currentTarget) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      
      handleStart();
    }
  };

  const handleStart = () => {

    // Shared start behavior: close any open MCAPS panel, then open the details panel and chat.
    const proceedStart = async () => {
      props.closeMCAPSPanel();
      props.validateURL();
      props.setDetailClick(false);
      props.handleStartClick();
      props.setTileSelected(props.serviceID);
      const handled = await props.checkIrisService();
      if (!handled) props.openPanel(props.serviceID, props.isRecommended, true);
    };

    proceedStart();
  };

  const handleDetails = () => {
    props.closeMCAPSPanel();
    props.handleDetailClick();
    props.openPanel(props.serviceID, props.isRecommended);
    props.setStartClick(false);
    props.setTileSelected(props.serviceID);
  };

  const handleUnpin = (e) => {
    e.stopPropagation();
    props.onDelete();
  };

  return (
    <div
      tabIndex={0}
      role="button"
      onKeyDown={handleKeyDown}
      className={props.styles.catalogTileFocusable}
      onFocus={() => {
        setFocusedTileID(props.serviceID);
      }}
      onBlur={() => {
        setFocusedTileID(null);
      }}
    >
      <Card
        hidden={isFeatureEnabled(props.title)}
        key={props.serviceID}
        className={`${props.styles.cardcomp} ${isHovered ? props.styles.cardHover : ""}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        {...props}
        style={{
          border: props.tileSelected === props.serviceID ? "2px solid #EAF4FF" : "",
          backgroundColor: props.tileSelected === props.serviceID ? "#EAF4FF" : "",
        }}
      >
        <div className={props.styles.headerconatiner}>
          <Text className={props.styles.title}>{props.title}</Text>
          {/* <Text className={styles.description}>{props.aboutService}</Text> */}
          <TooltipHost content={props.aboutService}>
            <Text className={props.styles.description}>{props.aboutService}</Text>
          </TooltipHost>
        </div>

        <div className={props.styles.infosectionconatiner}>
          <div className={props.styles.infoSection}>
            <Stack wrap tokens={{ childrenGap: 2 }}>
              <p style={{ color: "#595959", marginBottom: "0px" }}>
                <span>Help Provider:</span>
              </p>
              {props.help_Provider ? (
                <p style={{ color: "black", marginTop: "0px" }}>
                  {props.help_Provider}
                </p>
              ) : (
                <p style={{ color: "black", marginTop: "0px" }}>-</p>
              )}
            </Stack>
            {props.slA_logo ? (
              <img
                alt="icon"
                className={props.styles.iconImage}
                src={props.slA_logo + "?" + blobToken}
              />
            ) : (
              <img
                alt="icon"
                className={props.styles.iconImage}
                src={altImageUrl}
              />
            )}
          </div>

          <div className={props.styles.slaContainer}>
            <span className={props.styles.slaTitle}>SLA in days</span>
            <span className={props.styles.ownerTitle}>Owner</span>

            {props.slA_in_days ? (
              <span className={props.styles.slaValue}>{props.slA_in_days}</span>
            ) : (
              <span className={props.styles.slaValue}>-</span>
            )}
            {props.displayName ? (
              <span className={props.styles.ownerValue}>{props.displayName}</span>
            ) : (
              <span className={props.styles.ownerValue}>-</span>
            )}
          </div>
        </div>
        {/* Action menu that overlays */}
        <div
          className={`${props.styles.actionhoverMenu} ${
            isHovered || focusedTileID ? props.styles.actionhoverMenuVisible : ""
          }`}
        >
          <button
            type="button"
            className={props.styles.actionButton}
            onClick={handleStart}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
            title="Start"
            tabIndex={0}
          >
            <PlayCircle24Regular style={{
              width: 16,
              height: 16,
            }} />
            Start
          </button>
          <button
            className={props.styles.actionButton}
            onClick={handleDetails}
            onKeyDown={(e) => {
              e.stopPropagation();
              if (e.key === "Enter" || e.key === " ") {
                handleDetails();
              }
            }}
            title="Details"
            tabIndex={0}
          >
            <Icon iconName="Info" />
            Details
          </button>
          {!props.isRecommended && (
            <button
              className={props.styles.actionButton}
              onClick={handleUnpin}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleUnpin(e);
                }
              }}
              title="Unpin"
              tabIndex={0}
            >
              <PinOffRegular />
              Unpin
            </button>
          )}
          {props.isRecommended && (
            <button
              title="Pin"
              tabIndex={0}
              className={props.styles.actionButton}
              onClick={(e) => {
                e.stopPropagation();
                props.addToWorkspace(props.serviceID);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter" || e.key === " ") {
                  props.addToWorkspace(props.serviceID);
                }
              }}
            >
              <Icon iconName="Pinned" />
              Pin
            </button>
          )}
          {props.faqLink && (
            <button
              className={props.styles.actionButton}
              onClick={(e) => {
                e.stopPropagation();
                props.openFAQs(props.faqLink);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter" || e.key === " ") {
                  props.openFAQs(props.faqLink);
                }
              }}
              title="FAQ"
              tabIndex={0}
            >
              <Icon iconName="Help" />
              FAQ
            </button>
          )}
        </div>
      </Card>
    </div>
  );
};
// Generated by Copilot | 2026-10-26 | 8 lines added and 15 removed | Auto | 1321277 wait for Start routing before opening a legacy flyout | Time Taken 4 min
// Generated by Copilot | 2026-10-26 | 3 lines added and 3 removed | Auto | 1321278 rely on native button activation to avoid duplicate keyboard Starts | Time Taken 3 min
